import React from 'react';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@mui/material/Tooltip';
import {AiOutlineCheck} from 'react-icons/ai';

let AprobarAPEButton = (props) => {
    return (
        <Tooltip title="Aprobar APE">
            <IconButton
                style={{ color: '#449DD1' }}
                aria-label="Aprove"
                disabled={props.disabled}
                onClick={() => props.onClick()}
            >
                <AiOutlineCheck />
            </IconButton>
        </Tooltip>
    );
}

export default AprobarAPEButton;

  

